export default {
  id: "customTotalGrossProfit",
  name: "How much gross profit earned?",
  description:
    "See how much gross profit earned. This report only includes sales.",
  report: {
    name: "Total Gross Profit",
    chartType: "NUMBER",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "SaleItem",
      dimensions: [],
      measures: ["SaleItem.gross_profit"],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: false,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
